import React from 'react'
import { Alert, Snackbar, Box } from '@mui/material'

const IEWarningPopup = () => {
  const [open, setOpen] = React.useState(true)

  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  const link = (text, url) => (
    <a href={url} rel="noopener noreferrer" target="_blank">
      {text}
    </a>
  )

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      key="top,center"
      autoHideDuration={6000}
      onClose={handleClose}>
      <Alert onClose={handleClose} variant="filled" severity="warning">
        <Box component="p" sx={{
          marginTop: '-1px'
        }}>
          The Toyota Fleet Portal application does not support this browser - IE11.<br />
          For the best experience please update your browser to{' '}
          {link('Google Chrome', 'https://www.google.com/chrome/')},{' '}
          {link('Mozilla Firefox', 'https://www.mozilla.org/en-US/firefox/new/')}{' or '}
          {link('Microsoft Edge', 'https://www.microsoft.com/en-us/edge')} .
        </Box>
      </Alert>
    </Snackbar>
  )
}

export default IEWarningPopup
